import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "@/components/Navbar";

export function useScrollToTarget() {
  const location = useLocation();
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      window.history.replaceState({}, "");
      const t = setTimeout(() => scrollToSection(target), 250);
      return () => clearTimeout(t);
    }
  }, [location.state]);
}
